import { useQuery } from '@tanstack/react-query';
import {
  fetchLegacyCatalogMap,
  type LegacyCatalogMapResponse,
} from '../../services/legacyUserManager';

export const legacyCatalogMapQueryKey = [
  'admin',
  'legacy-users',
  'catalog-map',
] as const;

export function useLegacyCatalogMapQuery() {
  return useQuery<LegacyCatalogMapResponse>({
    queryKey: legacyCatalogMapQueryKey,
    queryFn: fetchLegacyCatalogMap,
  });
}
